import React from "react";
import ReactDOM from "react-dom";
import './fonts/password.ttf';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { unstable_createMuiStrictModeTheme as createMuiTheme, ThemeProvider } from "@material-ui/core";
import UserProvider from './providers/UserProvider';

const theme = createMuiTheme({
    palette: {
        primary: {
          light: '#439392',
          main: '#006564',
          dark: '#003a3a',
          contrastText: '#fff',
        },
        secondary: {
            light: "#86322b",
            main: "#540000",
            dark: "#330000",
            contrastText: "#fff",
        },
        reject: {
          main: '#540000',
        },
        unresolved: {
          main: 'orange',
        },
        // type: 'dark',
    },
});

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <UserProvider>
                <App />
            </UserProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
